import script from "./Status.vue?vue&type=script&setup=true&lang=js"
export * from "./Status.vue?vue&type=script&setup=true&lang=js"

import "./Status.vue?vue&type=style&index=0&id=ae0b06ce&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae0b06ce"]])

export default __exports__